import { Action, createReducer, on } from '@ngrx/store';
import * as CurrentUserActions from '../_actions/currentUser';
import { User } from '../_models';

export interface CurrentUserState {
  user: User | null;
  loading: boolean;
  error: any;
}

export const initialCurrentUserState: CurrentUserState = {
  user: null,
  loading: false,
  error: null,
};

export const currentUserReducer = createReducer(
  initialCurrentUserState,
  on(CurrentUserActions.setCurrentUser, (state, { user }) => ({
    ...state,
    user,
    loading: true,
    error: null,
  })),
  on(CurrentUserActions.setCurrentUserSuccess, (state, { user }) => ({
    ...state,
    user,
    loading: false,
  })),
  on(CurrentUserActions.updateCurrentUserSuccess, (state, { user }) => ({
    ...state,
    user, // Aggiorna il currentUser con l'utente aggiornato
  })),
  on(CurrentUserActions.setCurrentUserFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(CurrentUserActions.clearCurrentUser, (state) => ({
    ...state,
    user: null,
    loading: false,
    error: null,
  }))
);

export function reducer(state: CurrentUserState | undefined, action: Action) {
  return currentUserReducer(state, action);
}
